import Editor from './editor';

const SKDMaster = {
  Editor,
};

export default SKDMaster;
